module.exports = __webpack_public_path__ + "public/SiteImages/app-store.png?b95333ec";